import React from "react";
import TableRow from "../../../../Components/Common/TableRow";
import TableData from "../../../../Components/Common/TableData";
import { convertToLocalDateTime } from "../../../../utils/convertToLocalDateTime";
import { Link } from "react-router-dom";
import { studentUrls } from "../../../../Api/Auth/AppUrls";

const DashboardRow = ({ row, student = false }) => {
  const renderRowItem = (row) => {
    if (row.hasOwnProperty("subscription")) {
      const purchasedAt = row?.createdAt ? new Date(row?.createdAt) : null;
      const content = JSON.parse(row?.subscription?.content);
      const duration = content?.subscription_duration;
      const subscriptionDuration = duration ? parseInt(duration, 10) : 0;
      const expirationDate = new Date(purchasedAt);
      expirationDate.setDate(expirationDate.getDate() + subscriptionDuration);
      const today = new Date();
      const remainingDays = Math.max(
        0,
        Math.ceil((expirationDate - today) / (1000 * 60 * 60 * 24))
      );

      if (row.subscription?.title === "Subscription Materials")
        return (
          <Link
            to={
              !student
                ? "#"
                : row?.subscription?.category?.title === "Civil"
                ? studentUrls.studentSubscriptionMaterials
                : studentUrls.studentSubscriptionMaterialsMechanical
            }
          >
            Civil Subscription Materials
            {remainingDays > 0 ? (
              <span className="inline-block border border-green-500 text-green-700 bg-green-100 text-xs px-1 py-0.5 rounded ml-2">
                {` Expires in ${remainingDays} day${
                  remainingDays > 1 ? "s" : ""
                }
                `}
              </span>
            ) : (
              <span className="inline-block border border-red-500 text-red-700 bg-red-100 text-xs px-1 py-0.5 rounded ml-2">
                Expired
              </span>
            )}
          </Link>
        );
      else if (row.subscription?.title === "Practice Hub")
        return (
          <Link
            to={
              !student
                ? "#"
                : row?.subscription?.category?.title === "Civil"
                ? studentUrls.studentPracticeHub
                : studentUrls.studentPracticeHubMechanical
            }
          >
            Civil Practice Hub
            {remainingDays > 0 ? (
              <span className="inline-block border border-green-500 text-green-700 bg-green-100 text-xs px-1 py-0.5 rounded ml-2">
                {` Expires in ${remainingDays} day${
                  remainingDays > 1 ? "s" : ""
                }
                `}
              </span>
            ) : (
              <span className="inline-block border border-red-500 text-red-700 bg-red-100 text-xs px-1 py-0.5 rounded ml-2">
                Expired
              </span>
            )}
          </Link>
        );
      else if (
        row.subscription?.title === "Simulator" ||
        row.subscription?.title === "Mechanical Simulator"
      ) {
        return (
          <Link
            to={
              !student
                ? "#"
                : row?.subscription?.category?.title === "Civil"
                ? studentUrls.studentSimulatorCivil
                : studentUrls.studentSimulatorMechanical
            }
          >
            {row?.subscription?.category?.title === "Civil"
              ? "Simulator(Civil)"
              : "Simulator(Mechanical)"}
          </Link>
        );
      } else {
        return (
          <Link
            to={
              !student
                ? "#"
                : row?.subscription?.slug?.split("-").length === 2
                ? `/student/civil/${row.subscription.slug}`
                : `/student/${row.subscription.slug.replace("-", "/")}`
            }
          >
            {row.subscription?.title}

            {remainingDays > 0 ? (
              <span className="inline-block border border-green-500 text-green-700 bg-green-100 text-xs px-1 py-0.5 rounded ml-2">
                {` Expires in ${remainingDays} day${
                  remainingDays > 1 ? "s" : ""
                }
                `}
              </span>
            ) : (
              <span className="inline-block border border-red-500 text-red-700 bg-red-100 text-xs px-1 py-0.5 rounded ml-2">
                Expired
              </span>
            )}
          </Link>
        );
      }
    } else if (row.hasOwnProperty("package")) {
      const status = row?.packageStatus;
      return (
        <Link
          to={
            !student
              ? "#"
              : row?.package?.category?.title === "Civil"
              ? studentUrls.studentTutoring
              : studentUrls.studentTutoringMechanical
          }
        >
          {row.package?.title ? row.package?.title + " (Tutoring)" : ""}
          <span className="capitalize inline-block border border-green-500 text-green-700 bg-green-100 text-xs px-1 py-0.5 rounded ml-2">
            {status}
          </span>
        </Link>
      );
    } else if (row.hasOwnProperty("modelTest")) {
      console.log(row);

      const status = row?.modelTest;
      return (
        <Link
          to={
            !student
              ? "#"
              : status?.category?.title === "Civil"
              ? studentUrls.studentSimulatorCivil
              : studentUrls.studentSimulatorMechanical
          }
        >
          {status.title ? status?.title + " (Simulator)" : ""}
        </Link>
      );
    } else if (row.hasOwnProperty("liveClassSubscription")) {
      const status = getLiveClassStatus(
        row?.liveClassSubscription?.createdAt,
        row?.liveClassSubscription?.endDate
      );
      if (!row?.liveClassSubscription) {
        return;
      }
      return (
        <Link
          to={
            !student
              ? "#"
              : row?.liveClassSubscription?.category?.title === "Civil"
              ? studentUrls.liveClass
              : studentUrls.liveClassMechanical
          }
        >
          {row.liveClassSubscription?.title
            ? row.liveClassSubscription?.title + " (Live Class)"
            : ""}
          {status?.includes("Classes finished on") ? (
            <span className="inline-block border border-red-500 text-red-700 bg-red-100 text-xs px-1 py-0.5 rounded ml-2">
              {status}
            </span>
          ) : (
            <span className="inline-block border border-green-500 text-green-700 bg-green-100 text-xs px-1 py-0.5 rounded ml-2">
              {status}
            </span>
          )}
        </Link>
      );
    } else if (row.hasOwnProperty("test")) {
      return (
        <Link
          to={
            !student
              ? "#"
              : row?.test?.category?.title === "Civil"
              ? studentUrls.studentPaidModelTest
              : studentUrls.studentPaidModelTestMechanical
          }
        >
          {row.test?.title ? row.test?.title + " (Paid Model Test)" : ""}
        </Link>
      );
    }
  };

  const getLiveClassStatus = (startDateStr, endDateStr) => {
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);
    const now = new Date();

    // Format the date without the weekday
    const formatDate = (date) =>
      date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });

    if (now < startDate) {
      return `Starting on ${formatDate(startDate)}`;
    } else if (now >= startDate && now <= endDate) {
      return `Classes ongoing until ${formatDate(endDate)}`;
    } else {
      return `Classes finished on ${formatDate(endDate)}`;
    }
  };

  return (
    <>
      <TableRow key={row._id}>
        <TableData>{row._id}</TableData>
        <TableData>{renderRowItem(row)}</TableData>
        <TableData>{row?.user?.name}</TableData>
        <TableData>{row?.amount}</TableData>
        <TableData>{row?.transactionId}</TableData>
        <TableData>{convertToLocalDateTime(row.createdAt)}</TableData>
      </TableRow>
    </>
  );
};

export default DashboardRow;
